import {api} from '../config/api';

const PAGE_SIZE = 100; // the API's maximum per page

// /evenements answers one page at a time (50 by default, whatever the date range):
// walks every page so that a busy month is not cut off.
export const fetchAllEvents = async (accountId, params) => {
    const byId = new Map();
    let page = 1;
    let totalPages = 1;
    let totalItems = 0;

    do {
        const {data} = await api.get('/evenements', {
            headers: {'X-account-id': accountId, Accept: 'application/json'},
            params: {...params, page, itemsPerPage: PAGE_SIZE},
        });
        if (Array.isArray(data)) return data;

        // Appointments at the same time can come back on two pages: keep one of each
        (data?.data || data?.items || []).forEach((event) => byId.set(event?.id, event));
        totalPages = data?.pagination?.totalPages || 1;
        totalItems = data?.pagination?.totalItems || 0;
        page += 1;
    } while (page <= totalPages);

    if (byId.size < totalItems) {
        console.warn(`Rendez-vous chargés : ${byId.size} sur ${totalItems}`);
    }
    return [...byId.values()];
};
